import "./App.css";

import TopSection from "./components/TopSection/TopSection";
import SecondSection from "./components/SecondSection/SecondSection";
import DownloadSection from "./components/DownloadSection/DownloadSection";
import ContactSection from "./components/ContactSection/ContactSection";

function App() {
  return (
    <div className="App">
      <TopSection />
      <SecondSection />
      <DownloadSection />
      <ContactSection />
    </div>
  );
}

export default App;
